import Vue from "@/main";
import {
  iconColorFunc,
  styleOrLabel,
  materialOptionsFunc,
  outLineFunc,
  specialLineMaterial,
} from "./plotDictionaries";
import {
  changePolyLine,
  changePolygon,
  changeFillMaterial,
  changePolyLineMaterial,
  changeEllipsoidMaterial,
  changeEllipsoid,
} from "./config/privateChange";

// 接收当前场景的数据
let treeDataJson = null;
let prevPlotValue = null;
const changePrevPlotValue = (value) => {
  prevPlotValue = value;
};
const getPrevPlotValue = () => {
  return prevPlotValue;
};
// 静态默认值
const iconLineColor = "#5b8fee";
const defaultIconColor = "ffd700";

// 处理其他标绘可能存在添加点击事件
const otherClickEvent = (graphic, key) => {
  // console.log("otherClickEvent", key);
  const img = "image";
  const video = "play";
  const pdf = "pdf";
  const type =
    key === "imgList"
      ? img
      : key === "videoList"
      ? video
      : key === "pdfList"
      ? pdf
      : null;
  if (graphic.type == "point") {
    graphic.on(mars3d.EventType.click, (e) => {
      const clickE = e;
      clickE.currentTarget = {
        dataset: {
          type,
        },
      };
      // 弹出三方链接
      if (clickE.graphic.options.style.website) {
        console.log(clickE.graphic.options.style.website);
        openWindow(clickE.graphic.options.style.website, "", "1280", "720");
      }

      if (
        clickE.graphic.options.attr[key] &&
        clickE.graphic.options.attr[key].length > 0
      ) {
        menuOperate(clickE, clickE.graphic.options.attr[key]);
      }
    });
  } else {
    graphic.once(mars3d.EventType.click, (e) => {
      // console.log("otherClickEvent3");
      const clickE = e;
      clickE.currentTarget = {
        dataset: {
          type,
        },
      };
      if (
        clickE.graphic.options.attr[key] &&
        clickE.graphic.options.attr[key].length > 0
      ) {
        $(e.target._container)
          .find(".mars3d-camera-content")
          .on("click", (e) => {
            menuOperate(clickE, clickE.graphic.options.attr[key]);
          });
        $(e.target._container)
          .find(".marsBlueGradientPnl")
          .on("click", (e) => {
            menuOperate(clickE, clickE.graphic.options.attr[key]);
          });
      }
    });
  }
};

// 处理资源标绘添加事件
const addClickEvent = (graphic, attr) => {
  graphic.once(mars3d.EventType.click, (e) => {
    const clickE = e;
    // 第一次 选中
    $(e.target._container).find(".ss_menu").addClass("active");
    // 事件委托绑定click事件
    // 给 menu 绑定click事件
    $(e.target._container)
      .find(".ss_menu .menu")
      .on("click", function (e) {
        if ($(e.currentTarget).parent().hasClass("active")) {
          $(e.currentTarget).parent().removeClass("active");
        } else {
          $(".ss_menu.active").parent().removeClass("active");
          $(e.currentTarget).parent().addClass("active");
        }
      });
    $(e.target._container)
      .find(".ss_menu")
      .on("click", ".menu-image", (e) => {
        menuOperate(e, clickE.graphic.options.attr.imgList);
      });
  });
};

// 判断图层问题
const judgeLayer = (map, mapClone) => {
  if (
    !Vue.$GLOBAL.plotItemLayer ||
    !Vue.$GLOBAL.map.hasLayer(Vue.$GLOBAL.plotItemLayer.id)
  ) {
    let graphicLayer = new mars3d.layer.GraphicLayer();
    // 图层添加到map中
    map.addLayer(graphicLayer);
    Vue.$GLOBAL.plotItemLayer = graphicLayer;
  }
  if (mapClone) {
    map.addLayer(Vue.$GLOBAL.plotCloneItemLayer).then((res) => {
      console.log(res, "副屏加载图层");
    });
  }
};

// 处理提示文字
const addTooltip = (graphic, text) => {
  if (text) {
    graphic.bindTooltip(
      (e) => {
        return `<div class="prompCenter">
              <p class="prompWorkSpace">${text}</p>
              </div>`;
      },
      {
        offsetX: graphic.divWidth / 2 + Math.ceil(graphic.style.offsetX) - 5,
        offsetY: -graphic.divHeight + 15,
      }
    );
  } else {
    graphic.unbindTooltip();
  }
};
// 标绘通用属性(这里没有放plotName和高程，高程在修改时才添加)
let commonProperties = {
  scaleByDistance: false,
  distanceDisplayCondition: true,
  distanceDisplayCondition_far: 100000,
  clampToGround: false,
};
// 标绘通用文本属性
let textProperties = {
  text: "",
  font_family: "微软雅黑",
  font_size: 24,
  font_weight: "normal",
  font_style: "normal",
  color: "#ffffff",
  outline: true,
  outlineColor: "#0C121E",
  outlineWidth: 4,
  background: false,
  backgroundColor: "rgba(255, 215, 0, 0.8)",
  pixelOffsetX: 0,
  pixelOffsetY: -36,
  scaleByDistance: false,
  distanceDisplayCondition: false,
  distanceDisplayCondition_far: 100000,
  clampToGround: false,
  visibleDepth: false,
};
// 默认初始数据
let initObject = {
  text: "输入标绘内容",

  color: "#ffd700",
  iconInfo: "/img/marker/mark" + defaultIconColor + ".png", // 图标信息。可能含id、name、url。
  opacity: 1,
  font_size: 24,
  outlineWidth: 4, // 文本描边宽度。
  outlineColor: "#ffffff", // 文本描边颜色。
  background: false, //文本是否展示背景色。
  backgroundColor: "rgba(255, 215, 0, 0.8)", // 文本背景色。
  material: mars3d.MaterialType.Color, //材质。
  width: 10, //宽度，用于线、走廊标绘类型。
  clampToGround: false,
  radius: 60, // 圆形半径。
  diffHeight: 30, // 高度差。
  radii_x: 60.0, // 球体 x轴半径。
  radii_y: 60.0, // 球体 y轴半径。
  radii_z: 60.0, // 球体 z轴半径。
  remark: "标绘项内容",
  prompt: "",
  website: "",
  font_family: "微软雅黑",
  font_weight: "normal",
  font_style: "normal",
  outline: false,
  pixelOffsetX: 0,
  pixelOffsetY: 0,
  scaleByDistance: false,
  scaleByDistance_far: 100000,
  scaleByDistance_near: 0,
  distanceDisplayCondition: false,
  distanceDisplayCondition_far: 100000,
  distanceDisplayCondition_near: 0,
  visibleDepth: false,
  dashLength: 20,
  gapColor: "rgba(255,255,255,0)",
  glowPower: 0.2,
  bgColor: "#000000",
  speed: 10,
  bidirectional: 0,
  glow: 1.0,
  height: 0,
  fill: true,
  rotationDegree: 0,
  fillMaterial: mars3d.MaterialType.Color,
  count: 1,
  gradient: 0,
  polyGonMaterial: mars3d.MaterialType.Color,
  pixelSize: 10,
  scale: 1,
  polylineOutlineColor: "#ffffff",
  polylineOutlineWidth: 5,
  repeat_x: 10,
  ohterLineColor: "#0000FF",
  surfaceFillColor: "#0000FF",
  surfaceFillON: true,
  surfaceOutLine: true,
  surfaceOutLineColor: "#ffffff",
  surfaceOutLineWidth: 3,
  ellipsoidMaterial: mars3d.MaterialType.Color,
  cellAlpha: 0.1,
  lineCount: 10,
  lineThickness: 2,
  ellipsoidSpeed: 10,
};

// 编辑处理form字段
const manageFields = (data) => {
  const { customType, graphic, shapeType, textName } = data.bimPlanPainting;
  const dataId = data.id;
  const style = JSON.parse(graphic).style;

  const obj = {
    shapeType,
    commonProperties: {
      plotName: textName,
      scaleByDistance: style.scaleByDistance, //视距缩放
      distanceDisplayCondition: style.distanceDisplayCondition, //视距显示
      distanceDisplayCondition_far: style.distanceDisplayCondition_far, //最大距离
      clampToGround: style.clampToGround, //贴地
      setHeight: style.setHeight, //高程
    },
    form: {
      id: dataId, //id
      text: style?.label?.text ? style.label.text : style.text, //标绘名称
      color: iconColorFunc(style, customType), //标绘颜色
      opacity: style.opacity ? style.opacity : 1, //透明度
      font_size: style?.font_size, //文字大小
      clampToGround: style.clampToGround ? style.clampToGround : false, //是否贴地
      scaleByDistance: style?.scaleByDistance, //视距缩放
      outlineWidth: materialOptionsFunc(style, customType)?.outlineWidth, // 文本描边宽度。
      outlineColor: materialOptionsFunc(style, customType)?.outlineColor, // 文本描边颜色。
      background: style?.background, //文本是否展示背景色。
      backgroundColor: style?.backgroundColor, // 文本背景色。
      iconInfo: style?.imgae, // 图标信息。可能含id、name、url。
      radius: style?.radius, // 圆形半径。
      width: style?.width, //宽度，用于线、走廊标绘类型。
      remark: style?.remark,
      prompt: style?.prompt,
      material: specialLineMaterial(style),
      diffHeight: style?.diffHeight, // 高度差。
      radii_x: style?.radii_x, // 球体 x轴半径。
      radii_y: style?.radii_y, // 球体 y轴半径。
      radii_z: style?.radii_z, // 球体 z轴半径。
      font_family: style?.font_family,
      font_weight: style?.font_weight,
      font_style: style?.font_style,
      outline: outLineFunc(style, customType)?.outline,
      pixelOffsetX: styleOrLabel(style, customType)?.pixelOffsetX,
      pixelOffsetY: styleOrLabel(style, customType)?.pixelOffsetY,
      scaleByDistance_far: styleOrLabel(style, customType)?.scaleByDistance_far,
      scaleByDistance_near: styleOrLabel(style, customType)
        ?.scaleByDistance_near,
      distanceDisplayCondition: styleOrLabel(style, customType)
        ?.distanceDisplayCondition,
      distanceDisplayCondition_far: styleOrLabel(style, customType)
        ?.distanceDisplayCondition_far,
      distanceDisplayCondition_near: styleOrLabel(style, customType)
        ?.distanceDisplayCondition_near,
      visibleDepth: styleOrLabel(style, customType)?.visibleDepth,
      dashLength: materialOptionsFunc(style, customType)?.dashLength,
      gapColor: materialOptionsFunc(style, customType)?.gapColor,
      glowPower: materialOptionsFunc(style, customType)?.glowPower,
      bgColor: materialOptionsFunc(style, customType)?.bgColor,
      speed: materialOptionsFunc(style, customType, "circle")?.speed,
      bidirectional: materialOptionsFunc(style, customType)?.bidirectional,
      glow: materialOptionsFunc(style, customType)?.glow,
      height: style?.height,
      fill: style?.fill,
      rotationDegree: style?.rotationDegree,
      fillMaterial: style?.materialType,
      polyGonMaterial: style?.materialType,
      ellipsoidMaterial: style?.materialType,
      imgList: style?.imgList,
      website: style?.website,
      videoList: style?.videoList,
      count: materialOptionsFunc(style, customType, "circle")?.count,
      gradient: materialOptionsFunc(style, customType, "circle")?.gradient,
      pixelSize: style?.pixelSize,
      scale: style?.scale,
      polylineOutlineColor: style?.materialOptions?.outlineColor,
      polylineOutlineWidth: style?.materialOptions?.outlineWidth,
      repeat_x: style?.materialOptions?.repeat_x,
      ohterLineColor: style?.color,
      surfaceFillColor: style?.color,
      surfaceOutLine: style?.outline,
      surfaceFillON: style?.fill,
      surfaceOutLineColor: style?.outlineColor,
      surfaceOutLineWidth: style?.outlineWidth,
      lineCount: style?.materialOptions?.lineCount,
      lineThickness: style?.materialOptions?.lineThickness,
      cellAlpha: style?.materialOptions?.cellAlpha,
      ellipsoidSpeed: style?.materialOptions?.speed,
      isMirror: style?.isMirror, // 是否镜像。
    },
  };
  if (JSON.parse(graphic).type != "label") {
    obj.textProperties = style.label;
  }
  return obj;
};

// 对外暴露方法，点击资源树上的标记后自动定位功能或者返回将要编辑的对象
const flyToPlot = (id, operation) => {
  judgeLayer(Vue.$GLOBAL.map, false);
  if (treeDataJson && treeDataJson.children.length > 0) {
    const data = treeDataJson.children;
    const current = data.find((item) => item.id == id && item.uid);
    if (current) {
      let drawGraphic = Vue.$GLOBAL.plotItemLayer.getGraphicById(current.uid);
      if (drawGraphic && drawGraphic != undefined) {
        if (operation === "fly") {
          drawGraphic.flyTo();
        }
        if (operation === "edit") {
          return { drawGraphic, current };
        }
      } else {
        console.log("当前标绘未渲染");
        // Vue.$notify({
        //   title: `当前标绘未渲染`,
        //   message: "",
        //   type: "warning",
        //   duration: 960,
        //   offset: 320,
        // });
      }
    } else {
      console.log("当前标绘未渲染");
      // Vue.$notify({
      //   title: `当前标绘未渲染`,
      //   message: "",
      //   type: "warning",
      //   duration: 960,
      //   offset: 320,
      // });
    }
  } else {
    console.log("当前标绘未渲染");
    // Vue.$notify({
    //   title: `当前标绘未渲染`,
    //   message: "",
    //   type: "warning",
    //   duration: 960,
    //   offset: 320,
    // });
  }
};

// 对外暴露方法，接收场景下面的标绘id进行对应的创建
const operationPlotData = (isCreate, plotId, callback, ...list) => {
  // plotId就是外部传入的某一个标绘的id
  // isCreate是创建标绘还是删除标绘
  // callback回调函数
  // 地球
  try {
    console.log("创建标绘", isCreate, plotId, callback, ...list);
    let map = Vue.$GLOBAL.map;
    // 是否克隆
    let clone = null;
    if (list.length > 0) {
      clone = list[0].mapType;
      if (clone == "clone") {
        // 赋值克隆地球
        map = Vue.$GLOBAL.mapClone;
        // 创建克隆图层
        Vue.$GLOBAL.plotCloneItemLayer = new mars3d.layer.GraphicLayer();
        // 判断图层，同时副屏加图层
        judgeLayer(map, clone);
      } else {
        clone = null;
      }
    }
    // 判断图层，同时可能给副屏加图层
    judgeLayer(map, false);
    // 判断数据被传递过来并且children中有数据
    if (treeDataJson && treeDataJson.children.length > 0) {
      const data = treeDataJson.children;
      for (let i = 0; i < data.length; i++) {
        if (data[i].id == plotId) {
          if (isCreate && isCreate !== "false") {
            if (!clone && data[i]?.uid) {
              const plot = Vue.$GLOBAL.plotItemLayer.getGraphicById(
                data[i]?.uid
              );
              if (plot) {
                console.log("主屏的标绘已经存在了", plot);
                break;
              }
            }
            if (clone && data[i]?.cloneUid) {
              const plot = Vue.$GLOBAL.plotCloneItemLayer.getGraphicById(
                data[i]?.cloneUid
              );
              if (plot) {
                console.log("副屏的标绘已经存在了", plot);
                break;
              }
            }
            // 把图层做成全局直接添加进去就ok了
            const { graphic, shapeType } = data[i].bimPlanPainting;
            const JsonGraphic = JSON.parse(graphic);
            JsonGraphic.serviceId = data[i].id;
            const addGraphic =
              !clone && Vue.$GLOBAL.plotItemLayer.addGraphic(JsonGraphic);
            const addGraphicClone =
              clone && Vue.$GLOBAL.plotCloneItemLayer.addGraphic(JsonGraphic);
            // 资源标绘
            if (shapeType == 5) {
              const attr = JsonGraphic.attr;
              if (attr.imgList) {
                // 添加事件
                !clone && addClickEvent(addGraphic, attr);
                clone && addClickEvent(addGraphicClone, attr);
              }
            }
            // 其他类型标绘加了图片点击的
            if (JsonGraphic?.attr || JsonGraphic?.style.website) {
              if (JsonGraphic?.style.website) {
                !clone && otherClickEvent(addGraphic, "website");
                clone && otherClickEvent(addGraphicClone, "website");
              }

              Object.keys(JsonGraphic.attr).forEach((item) => {
                if (item === "imgList" || item === "videoList") {
                  !clone && otherClickEvent(addGraphic, item);
                  clone && otherClickEvent(addGraphicClone, item);
                }
              });
            }
            // 提示文字标绘
            if (
              (addGraphic && addGraphic.style.toolTips === "prompt") ||
              (addGraphicClone && addGraphicClone.style.toolTips === "prompt")
            ) {
              !clone && addTooltip(addGraphic, addGraphic.style.prompt);
              clone &&
                addTooltip(addGraphicClone, addGraphicClone.style.prompt);
            }
            // 网址
            // if (
            //   (addGraphic && addGraphic.style.toolTips === "website") ||
            //   (addGraphicClone && addGraphicClone.style.toolTips === "website")
            // ) {
            //   !clone && addTooltip(addGraphic, addGraphic.style.website);
            //   clone && addTooltip(addGraphicClone, addGraphicClone.style.website);
            // }
            // 记录当前添加进去的uid
            if (addGraphic) data[i].uid = addGraphic && addGraphic.id; //主
            data[i].cloneUid = addGraphicClone && addGraphicClone.id; //副
            if (callback && i == data.length - 1) {
              callback(Promise.resolve(true));
            }
            break;
          } else {
            // 判断当前标绘是否创建再地图上，创建了就一定有uid
            if (data[i].uid) {
              // 根据添加时候存储的uid返回当前对象
              console.log("移除标绘", data[i]);
              let drawGraphic = Vue.$GLOBAL.plotItemLayer.getGraphicById(
                data[i].uid
              );
              console.log("移除标绘", drawGraphic);
              if (drawGraphic) {
                Vue.$GLOBAL.plotItemLayer.removeGraphic(drawGraphic);
                data[i].uid = null;
              }
              // 删除
              break;
            }
          }
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
};

// 对外暴露方法，接收场景下面的整体标绘数据数组
const receivePlotTreeData = (data) => {
  if (data.children.length > 0) {
    data.children.forEach((item) => {
      item.bimPlanPainting = {
        ...item,
      };
      if (item.pId == 0) {
        item.parentId = data.parentId;
      } else {
        item.parentId = item.pId;
      }
      if (treeDataJson) {
        treeDataJson.children.forEach((etem) => {
          if (item.id == etem.id) {
            item.uid = etem.uid;
          }
        });
      }
      if (!item.uid) {
        item.uid = JSON.parse(item.graphic).id;
      }
    });
  }
  treeDataJson = JSON.parse(JSON.stringify(data));
};

// 将当前场景下的标绘数据导出
const currentScenePlot = () => {
  return treeDataJson;
};

// 除了脚本以外的其他入口打开标绘时，接收项目下整体的标绘树据数组
const getProjectPlotTreeData = (data) => {
  const obj = {
    children: [],
  };
  data.forEach((item) => {
    if (item.children.length > 0) {
      item.children.forEach((ytem) => {
        ytem.uid = JSON.parse(ytem.bimPlanPainting.graphic).id;
        ytem.graphic = ytem.bimPlanPainting.graphic;
      });

      obj.children = obj.children.concat(item.children);
    }
  });
  console.log("treeDataJson2", treeDataJson, obj);
  treeDataJson = obj;
};

// 对外暴露方法,删除当前图层上所有的标绘
const deleteAllPlot = () => {
  if (Vue.$GLOBAL.plotItemLayer) {
    try {
      Vue.$GLOBAL.plotItemLayer.clear();
    } catch (error) {
      console.log(error);
    }
  }
  if (Vue.$GLOBAL.plotCloneItemLayer) {
    try {
      Vue.$GLOBAL.plotCloneItemLayer.clear();
    } catch (error) {
      console.log(error);
    }
  }
};

// 对外暴露方法,清空暂存数据
const clearPlotData = () => {
  treeDataJson = null;
};

// 循环根据类型创建不同的标绘（绝大部分）
const graphicDrawFunc = (type1, type2, layer, callback, prevValue) => {
  for (let i = 0; i < styleList.length; i++) {
    if (styleList[i].type === type1) {
      const style = prevValue
        ? prevValue
        : JSON.parse(JSON.stringify(styleList[i].style));
      return layer
        .startDraw({ type: type2, style, isPrative: "add" })
        .then((res) => {
          // 如果你是那种提示文字类型
          if (style?.prompt) {
            addTooltip(res, style.prompt);
          }
          callback(style);
        });
    }
  }
};

// 匹配最新增加的标绘,返回ID,赋值UID(因最新落地的标绘无法根据唯一值进行编辑所做)
const matchPlotId = (current) => {
  for (let i = 0; i < treeDataJson.children.length; i++) {
    const data = treeDataJson.children[i];
    if (
      JSON.parse(data.graphic).id === current.graphic.id &&
      current.graphic.options.isPrative === "add"
    ) {
      // 赋值uid
      data.uid = current.graphic.id;
      return data.id;
    }
  }
};

// 修改样式（大部分）
const changeGraphicStyle = (key, type, graphic, form) => {
  console.log(key);
  console.log(type);
  console.log(form);
  console.log(form.plotType);
  console.log(graphic);
  if (key === "iconInfo" && type === "billboard") {
    graphic.setStyle({
      image: form[key],
    });
    return;
  }
  // 军标箭头修改
  if (type === "fineArrowYW") {
    if (key === "ohterLineColor") {
      graphic.setStyle({
        color: form[key],
      });
      return;
    }
  }
  if (key === "prompt") {
    graphic.setStyle({
      [key]: form[key],
    });
    addTooltip(graphic, form[key]);
    return;
  }
  // 针对图片资源
  if (key === "imgList" || key === "videoList") {
    // 赋值
    graphic.attr[key] = form[key];
    graphic.setStyle({
      [key]: form[key],
    });
    if (form[key].length > 0) {
      otherClickEvent(graphic, key);
    }
    return;
  }
  // 针对图片资源
  if (key === "website") {
    graphic.setStyle({
      [key]: form[key],
    });
    if (form[key].length > 0) {
      otherClickEvent(graphic, key);
    }
  }

  // 针对透明度在materialOptions属性存在时不生效
  if (key === "opacity") {
    graphic.setStyle({
      opacity: form[key],
    });
    if (graphic?.style?.materialOptions?.color) {
      let rgba = graphic.style.materialOptions.color.match(/(\d(\.\d+)?)+/g);
      rgba[3] = form[key];
      graphic.setStyle({
        materialOptions: { ["color"]: `rgba(${rgba.join()})` },
      });
    }
  }
  if (form.plotType === "newBorderText") {
    if (key === "remark") {
      const context = JSON.stringify(form[key])
        .replace(/\\n/g, "<br/>")
        .replaceAll('"', "");
      const newHtml = $(graphic.style.html)
        .find(".marsBlueGradientPnlTitle")
        .html(context)
        .end()[0].outerHTML;
      graphic.setStyle({
        html: newHtml,
        remark: form[key],
      });
      return;
    }
  }
  if (form.plotType === "tempPointToIconInset") {
    if (key === "remark") {
      const context = JSON.stringify(form[key])
        .replace(/\\n/g, "<br/>")
        .replaceAll('"', "");
      const newHtml = $(graphic.style.html)
        .find(".marsBlueGradientPnlJump")
        .html(context)
        .end()[0].outerHTML;
      graphic.setStyle({
        html: newHtml,
        remark: form[key],
      });
      return;
    }
  }
  // 针对矩形的标绘颜色
  if (type === "rectangle") {
    if (key == "color") {
      graphic.setStyle({
        materialOptions: { [key]: form[key] },
      });
      graphic.setStyle({
        [key]: form[key],
      });
      return;
    }
  }
  // 针对自定义标绘（资源视频）
  if (key == "video") {
  }
  // 针对自定义标绘（资源pdf）
  if (key == "pdf") {
  }
  // 针对标题说明
  if (form.plotType === "dynamicExplain") {
    if (key == "text") {
      if (!form[key]) {
        return;
      }
      const newHtml = $(graphic.style.html)
        .find(".title")
        .html(form[key])
        .end()[0].outerHTML;
      graphic.setStyle({
        html: newHtml,
        text: form[key],
      });
      return;
    }
    if (key == "remark") {
      const newHtml = $(graphic.style.html)
        .find(".content")
        .html(form[key])
        .end()[0].outerHTML;
      graphic.setStyle({
        html: newHtml,
        remark: form[key],
      });
      return;
    }
  }
  // 针对自定义标绘（资源图片）
  if (key == "img") {
    // 赋值
    graphic.attr.imgList = form.imgList;
    // 查找有没有img的class，实则就是检查你在创建当前标绘时，是不是有创建img类型
    const oldHtml = $(graphic.style.html).find(".menu-image")[0];
    let newHtml = null;
    // 没有就添加进去
    if (!oldHtml) {
      newHtml = $(graphic.style.html).prepend(resourcesImg);
      graphic.setStyle({
        html: newHtml,
      });
    }
    return;
  }
  // 针对动态边框文本
  if (type == "divBoderLabel") {
    if (key == "text") {
      if (!form[key]) {
        return;
      }
      const newHtml = $(graphic.style.html)
        .find(".mars3d-divBoderLabel-text")
        .html(form[key])
        .end()[0].outerHTML;
      graphic.setStyle({
        html: newHtml,
        text: form[key],
      });
      return;
    }
  }
  // 针对竖直文本
  if (type == "divUpLabel") {
    if (key == "text") {
      if (!form[key]) {
        return;
      }
      const newHtml = $(graphic.style.html)
        .find(".mars3d-divUpLabel-text")
        .html(form[key])
        .end()[0].outerHTML;
      graphic.setStyle({
        html: newHtml,
        text: form[key],
      });
      return;
    }
  }
  // 针对说明
  if (graphic.style?.highlight?.className) {
    if (key == "text") {
      if (!form[key]) {
        return;
      }
      const newHtml = $(graphic.style.html)
        .find(".marsBlackPanel-text")
        .html(`<span>${form[key]}</span>`)
        .end()[0].outerHTML;
      graphic.setStyle({
        html: newHtml,
        text: form[key],
      });
      return;
    }

    if (key == "isMirror") {
      // if (!form[key]) {
      //   return;
      // }
      let newHtml;
      if (form[key]) {
        newHtml = $(graphic.style.html).addClass("isMirror")[0].outerHTML;
      } else {
        newHtml = $(graphic.style.html).removeClass("isMirror")[0].outerHTML;
      }

      graphic.setStyle({
        html: newHtml,
      });
    }
  }
  // 面属性修改
  if (
    type === "polygon" ||
    type === "rectangle" ||
    (type === "circle" && key !== "fillMaterial")
  ) {
    changePolygon(type, key, graphic, form);
    return;
  }

  // 圆形的类别
  if (key === "fillMaterial") {
    changeFillMaterial(type, key, graphic, form);
    return;
  }
  // 针对修改线型的（材质）
  if (key === "material") {
    changePolyLineMaterial(type, key, graphic, form);
    return;
  }
  // 线属性修改
  if (changePolyLine(graphic.style.materialType, key, graphic, form)) return;
  // 半球材质修改
  if (key === "ellipsoidMaterial") {
    changeEllipsoidMaterial(type, key, graphic, form);
    return;
  }
  // 半球材质对应属性修改
  if (changeEllipsoid(type, key, graphic, form)) return;

  if (key === "isMirror") {
  }
  // 默认在label外面的
  graphic.setStyle({
    [key]: form[key],
  });
  return;
};

// 开始绘制时对应类型的默认样式
const styleList = [
  // 点
  {
    type: "dot",
    style: {
      label: {
        ...textProperties,
        font_family: "楷体",
        text: "",
        // scaleByDistance_far: 10000,
        // scaleByDistance_near: 20,
        // scaleByDistance_nearValue: 1,
      },
      color: initObject.color,
      pixelSize: initObject.pixelSize,
      outline: true,
      outlineColor: initObject.outlineColor,
      outlineWidth: 2,
      prompt: initObject.prompt,
      toolTips: "prompt",
      visibleDepth: false,
      ...commonProperties,
      // scaleByDistance_far: 10000,
      // scaleByDistance_near: 20,
      // scaleByDistance_nearValue: 1,
    },
  },
  // 文本
  {
    type: "text",
    style: {
      text: initObject.text,
      font_family: initObject.font_family,
      font_size: initObject.font_size,
      font_weight: initObject.font_weight,
      font_style: initObject.font_style,
      color: "#ffffff",
      outline: true,
      outlineWidth: 4,
      outlineColor: "#0C121E",
      background: initObject.background,
      backgroundColor: "rgba(255, 215, 0, 0.8)",
      pixelOffsetX: initObject.pixelOffsetX,
      pixelOffsetY: initObject.pixelOffsetY,
      visibleDepth: initObject.visibleDepth,
      backgroundPadding: 10,
      ...commonProperties,
      // scaleByDistance_far: 10000,
      // scaleByDistance_near: 20,
      // scaleByDistance_nearValue: 1,
    },
  },
  // 竖直文本
  {
    type: "verticalText",
    style: {
      text: initObject.text,
      color: "#ffffff",
      font_size: initObject.font_size,
      font_family: initObject.font_family,
      ...commonProperties,
    },
  },
  // 动态边框文本
  {
    type: "dynamicBorderText",
    style: {
      text: initObject.text,
      color: "#ffffff",
      boderColor: "#15d1f2",
      font_size: initObject.font_size,
      font_family: initObject.font_family,
      ...commonProperties,
    },
  },
  // 图标文字
  {
    type: "icon",
    style: {
      image: initObject.iconInfo,
      width: 30,
      height: 30,
      label: {
        ...textProperties,
        text: "输入标绘内容",
      },
      visibleDepth: false,
      ...commonProperties,
    },
  },
  // 指向说明（样式一）
  {
    type: "explain",
    style: {
      html: `<div class="marsBlackPanel  animation-spaceInDown">
              <div class="marsBlackPanel-text"><span>${initObject.text}</span></div>
              <div class="circular"></div>
          </div>`,
      isMirror: false,
      horizontalOrigin: 1,
      verticalOrigin: 1,
      // 高亮时的样式
      highlight: {
        // type: mars3d.EventType.click,
        className: "marsBlackPanel-highlight",
      },
      font_family: initObject.font_family,
      text: initObject.text,
      ...commonProperties,
    },
  },
  // 指向说明（样式二）
  {
    type: "dynamicExplain",
    style: {
      html: `<div class="marsImgPanel2">
              <div class="title">标绘项名称</div>
              <div class="content">标绘项内容</div>
          </div >`,
      horizontalOrigin: 1,
      verticalOrigin: 1,
      text: initObject.text,
      remark: initObject.remark,
      ...commonProperties,
    },
  },
  // 动态文本框
  {
    type: "tempPointToIconInset",
    style: {
      html: `<div style="font-family:Microsoft YaHei;">
              <div class="mars3d-camera-content" style="position: absolute;
                                                                          height: auto;
                                                                          bottom: 150px;
                                                                          width: 300px;
                                                                          left: -106px;
                                                                          display: flex;
                                                                          justify-content: center;">
                <div class="marsBlueGradientPnlJump">标绘项内容</div>
              </div>
              <div class="mars3d-camera-line" style="border-left-color:${iconLineColor};width: 88.52px;"></div>
              <div class="mars3d-camera-point" style="background-color:${iconLineColor}"></div>
            <div>`,
      offsetX: -40.5,
      offsetY: 3,
      text: initObject.text,
      remark: initObject.remark,
      prompt: initObject.prompt,
      toolTips: "prompt",
      clampToGround: false,
      ...commonProperties,
    },
  },
  // 新加的
  {
    type: "newBorderText",
    style: {
      html: `<div class="marsBlueGradientPnl">
                <div class="marsBlueGradientPnlTitle">${initObject.text}</div>
            </div>`,
      offsetX: -50.5,
      offsetY: -60,
      text: initObject.text,
      remark: initObject.remark,
      prompt: initObject.prompt,
      toolTips: "prompt",
      clampToGround: false,
      ...commonProperties,
    },
  },
  // 直线
  {
    type: "solidLine",
    style: {
      label: textProperties,
      width: initObject.width,
      materialType: "Color",
      materialOptions: {
        color: initObject.color,
      },
      ...commonProperties,
    },
  },
  // 曲线
  {
    type: "curve",
    style: {
      label: textProperties,
      width: initObject.width,
      materialType: "Color",
      materialOptions: {
        color: initObject.color,
      },
      ...commonProperties,
    },
  },
  // 箭头线
  {
    type: "devetailArrowLine",
    style: {
      label: textProperties,
      color: initObject.ohterLineColor,
      outline: initObject.outline,
      outlineColor: initObject.outlineColor,
      outlineWidth: initObject.outlineWidth,
      ...commonProperties,
    },
  },
  // 面_多边形
  {
    type: "polygon",
    style: {
      label: textProperties,
      color: initObject.surfaceFillColor,
      outline: initObject.surfaceOutLine,
      fill: initObject.surfaceFillON,
      outlineColor: initObject.surfaceOutLineColor,
      outlineWidth: initObject.surfaceOutLineWidth,
      visibleDepth: false,
      ...commonProperties,
    },
  },
  // 面_矩形
  {
    type: "rectangle",
    style: {
      label: textProperties,
      color: initObject.surfaceFillColor,
      outline: initObject.surfaceOutLine,
      fill: initObject.surfaceFillON,
      outlineColor: initObject.surfaceOutLineColor,
      outlineWidth: initObject.surfaceOutLineWidth,
      ...commonProperties,
    },
  },
  // 面_圆
  {
    type: "circle",
    style: {
      label: textProperties,
      color: initObject.surfaceFillColor,
      outline: initObject.surfaceOutLine,
      fill: initObject.surfaceFillON,
      outlineColor: initObject.surfaceOutLineColor,
      outlineWidth: initObject.surfaceOutLineWidth,
      ...commonProperties,
    },
  },
  // 体_半球
  {
    type: "sphere",
    style: {
      label: textProperties,
      color: initObject.color,
      ...commonProperties,
      clampToGround: false,
      distanceDisplayCondition: false,
    },
  },
];

// 配置标绘项属性显示
const isFieldDisplayed = (type) => {
  let arr = [];
  if (type) {
    switch (type) {
      case "dot":
        arr = [
          "outline",
          "outlineWidth",
          "outlineColor",
          "pixelSize",
          "color",
          "prompt",
          "imgList",
          "videoList",
          "website",
        ];
        break;
      case "text":
        arr = [
          "name",
          "font_family",
          "font_weight",
          "font_style",
          "outline",
          "pixelOffsetX",
          "pixelOffsetY",
          "visibleDepth",
          "color",
          "font_size",
          "outlineWidth",
          "outlineColor",
          "background",
          "backgroundColor",
        ];
        break;
      case "solidLine":
        arr = [
          "color",
          "dashLength",
          "gapColor",
          "glowPower",
          "bgColor",
          "speed",
          "bidirectional",
          "glow",
          "polylineOutlineWidth",
          "polylineOutlineColor",
          "material",
          "repeat_x",
          "width",
        ];
        break;
      case "curve":
        arr = [
          "color",
          "dashLength",
          "gapColor",
          "glowPower",
          "bgColor",
          "speed",
          "bidirectional",
          "glow",
          "polylineOutlineWidth",
          "polylineOutlineColor",
          "material",
          "repeat_x",
          "width",
        ];
        break;
      case "polygon":
        arr = [
          "surfaceFillON",
          "surfaceFillColor",
          "surfaceOutLine",
          "surfaceOutLineColor",
          "surfaceOutLineWidth",
          "diffHeight",
        ];
        break;
      case "rectangle":
        arr = [
          "surfaceFillON",
          "surfaceFillColor",
          "surfaceOutLine",
          "surfaceOutLineColor",
          "surfaceOutLineWidth",
          "diffHeight",
        ];
        break;
      case "circle":
        arr = [
          "fillMaterial",
          "count",
          "gradient",
          "radius",
          "speed",
          "surfaceFillON",
          "surfaceFillColor",
          "surfaceOutLine",
          "surfaceOutLineColor",
          "surfaceOutLineWidth",
          "diffHeight",
        ];
        break;
      case "sphere":
        arr = [
          "ellipsoidMaterial",
          "color",
          "radii_x",
          "radii_y",
          "radii_z",
          "cellAlpha",
          "lineCount",
          "lineThickness",
          "ellipsoidSpeed",
        ];
        break;
      case "verticalText":
        arr = ["name"];
        break;
      case "dynamicBorderText":
        arr = ["name"];
        break;
      case "icon":
        arr = ["scale", "iconChange"];
        break;
      case "tempPointToIconInset":
        arr = ["remark", "prompt", "imgList", "videoList"];
        break;
      case "newBorderText":
        arr = ["remark", "prompt", "imgList", "videoList"];
        break;
      case "explain":
        arr = ["name", "isMirror"];
        break;
      case "dynamicExplain":
        arr = ["name", "remark"];
        break;
      case "devetailArrowLine":
        arr = ["ohterLineColor", "outline", "outlineWidth", "outlineColor"];
        break;
      default:
        arr = [];
        break;
    }
  } else {
    arr = [];
  }
  return arr;
};

// 初始化表单
// 1是输入框，2是颜色选择器，3是进度条，4是数字输入框，5是switch，6是下拉框，7是提交按钮
const initFormList = [
  {
    show: "name",
    key: "text",
    type: 1,
    isShow: true,
  },
  {
    show: "remark",
    key: "remark",
    type: 1,
    isShow: true,
  },
  {
    show: "isMirror",
    key: "isMirror",
    type: 5,
    isShow: true,
  },
  {
    show: "prompt",
    key: "prompt",
    type: 1,
    isShow: true,
  },
  {
    show: "material",
    key: "material",
    type: 6,
    isShow: true,
  },
  {
    show: "fillMaterial",
    key: "fillMaterial",
    type: 6,
    isShow: true,
  },
  {
    show: "polyGonMaterial",
    key: "polyGonMaterial",
    type: 6,
    isShow: true,
  },
  {
    show: "ellipsoidMaterial",
    key: "ellipsoidMaterial",
    type: 6,
    isShow: true,
  },
  {
    show: "cellAlpha",
    key: "cellAlpha",
    type: 3,
    min: 0.1,
    max: 1,
    step: 0.1,
    isShow: false,
  },
  {
    show: "lineCount",
    key: "lineCount",
    type: 4,
    min: 0,
    max: 100,
    step: 1,
    isShow: false,
  },
  {
    show: "lineThickness",
    key: "lineThickness",
    type: 4,
    min: 0,
    max: 100,
    step: 1,
    isShow: false,
  },
  {
    show: "ellipsoidSpeed",
    key: "ellipsoidSpeed",
    type: 4,
    min: 0,
    max: 20,
    step: 1,
    isShow: false,
  },

  {
    show: "font_family",
    key: "font_family",
    type: 6,
    isShow: true,
  },
  {
    show: "font_weight",
    key: "font_weight",
    type: 6,
    isShow: true,
  },
  {
    show: "font_style",
    key: "font_style",
    type: 6,
    isShow: true,
  },
  {
    show: "bidirectional",
    key: "bidirectional",
    type: 6,
    isShow: false,
  },
  {
    show: "imgList",
    key: "imgList",
    type: 8,
    isShow: true,
  },
  {
    show: "videoList",
    key: "videoList",
    type: 8,
    isShow: true,
  },
  {
    show: "website",
    key: "website",
    type: 0,
    isShow: true,
  },
  {
    show: "color",
    key: "color",
    type: 2,
    isShow: true,
  },
  {
    show: "ohterLineColor",
    key: "ohterLineColor",
    type: 2,
    isShow: true,
  },
  {
    show: "gapColor",
    key: "gapColor",
    type: 2,
    isShow: false,
  },
  {
    show: "bgColor",
    key: "bgColor",
    type: 2,
    isShow: false,
  },
  {
    show: "opacity",
    key: "opacity",
    type: 3,
    min: 0,
    max: 1,
    step: 0.01,
    isShow: true,
  },
  {
    show: "gradient",
    key: "gradient",
    type: 3,
    min: 0,
    max: 1,
    step: 0.1,
    isShow: false,
  },
  {
    show: "font_size",
    key: "font_size",
    type: 4,
    min: 10,
    max: 1000,
    step: 2,
    isShow: true,
  },
  {
    show: "pixelSize",
    key: "pixelSize",
    type: 4,
    min: 10,
    max: 1000,
    step: 10,
    isShow: true,
  },
  {
    show: "glowPower",
    key: "glowPower",
    type: 4,
    min: 0,
    max: 1,
    step: 0.1,
    isShow: false,
  },
  {
    show: "speed",
    key: "speed",
    type: 4,
    min: 0,
    max: 100,
    step: 10,
    isShow: false,
  },
  {
    show: "count",
    key: "count",
    type: 4,
    min: 1,
    max: 100000,
    step: 1,
    isShow: false,
  },
  {
    show: "glow",
    key: "glow",
    type: 4,
    min: 0,
    max: 100,
    step: 1,
    isShow: false,
  },
  {
    show: "width",
    key: "width",
    type: 4,
    min: 1,
    max: 100,
    step: 2,
    isShow: true,
  },
  {
    show: "radius",
    key: "radius",
    type: 4,
    min: 0.1,
    max: 1000000,
    step: 10,
    isShow: true,
  },
  {
    show: "diffHeight",
    key: "diffHeight",
    type: 4,
    min: 0,
    max: 1000000,
    step: 5,
    isShow: true,
  },
  {
    show: "radii_x",
    key: "radii_x",
    type: 4,
    min: 1,
    max: 1000000,
    step: 10,
    isShow: true,
  },
  {
    show: "radii_y",
    key: "radii_y",
    type: 4,
    min: 1,
    max: 1000000,
    step: 10,
    isShow: true,
  },
  {
    show: "radii_z",
    key: "radii_z",
    type: 4,
    min: 1,
    max: 1000000,
    step: 10,
    isShow: true,
  },
  {
    show: "pixelOffsetX",
    key: "pixelOffsetX",
    type: 4,
    min: 0,
    max: 1000,
    step: 10,
    isShow: true,
  },
  {
    show: "pixelOffsetY",
    key: "pixelOffsetY",
    type: 4,
    min: 0,
    max: 1000,
    step: 10,
    isShow: true,
  },
  {
    show: "height",
    key: "height",
    type: 4,
    min: 0,
    max: 1000000,
    step: 10,
    isShow: true,
  },
  {
    show: "dashLength",
    key: "dashLength",
    type: 4,
    min: 1,
    max: 100,
    step: 1,
    isShow: false,
  },
  {
    show: "rotationDegree",
    key: "rotationDegree",
    type: 4,
    min: -Infinity,
    max: Infinity,
    step: 1,
    isShow: true,
  },
  {
    show: "iconChange",
    key: "iconChange",
    type: 10,
    isShow: true,
  },
  {
    show: "scale",
    key: "scale",
    type: 4,
    min: 1,
    max: 20,
    step: 1,
    isShow: true,
  },
  {
    show: "repeat_x",
    key: "repeat_x",
    type: 4,
    min: 1,
    max: 100,
    step: 1,
    isShow: false,
  },
  {
    show: "outline",
    key: "outline",
    type: 5,
    activeTtext: "开启",
    inactiveText: "取消",
    isShow: true,
  },
  {
    show: "surfaceFillON",
    key: "surfaceFillON",
    type: 5,
    activeTtext: "开启",
    inactiveText: "取消",
    isShow: true,
  },
  {
    show: "surfaceFillColor",
    key: "surfaceFillColor",
    type: 2,
    isShow: true,
  },
  {
    show: "surfaceOutLine",
    key: "surfaceOutLine",
    type: 5,
    activeTtext: "开启",
    inactiveText: "取消",
    isShow: true,
  },

  {
    show: "polylineOutlineColor",
    key: "polylineOutlineColor",
    type: 2,
    isShow: false,
  },
  {
    show: "outlineColor",
    key: "outlineColor",
    type: 2,
    isShow: false,
  },
  {
    show: "surfaceOutLineColor",
    key: "surfaceOutLineColor",
    type: 2,
    isShow: true,
  },
  {
    show: "surfaceOutLineWidth",
    key: "surfaceOutLineWidth",
    type: 4,
    min: 1,
    max: 1000,
    step: 1,
    isShow: true,
  },
  {
    show: "outlineWidth",
    key: "outlineWidth",
    type: 4,
    min: 1,
    max: 1000,
    step: 1,
    isShow: false,
  },
  {
    show: "polylineOutlineWidth",
    key: "polylineOutlineWidth",
    type: 4,
    min: 1,
    max: 100,
    step: 1,
    isShow: false,
  },
  {
    show: "outlineColor",
    key: "outlineColor",
    type: 2,
    isShow: false,
  },
  {
    show: "outlineWidth",
    key: "outlineWidth",
    type: 4,
    min: 0,
    max: 10,
    step: 0.5,
    isShow: false,
  },
  {
    show: "fill",
    key: "fill",
    type: 5,
    activeTtext: "是",
    inactiveText: "否",
    isShow: true,
  },
  {
    show: "background",
    key: "background",
    type: 5,
    activeTtext: "展示",
    inactiveText: "不展示",
    isShow: true,
  },
  {
    show: "backgroundColor",
    key: "backgroundColor",
    type: 2,
    isShow: false,
  },
  {
    show: "visibleDepth",
    key: "visibleDepth",
    type: 5,
    activeTtext: "是",
    inactiveText: "否",
    isShow: true,
  },
  {
    show: "clampToGround",
    key: "clampToGround",
    type: 5,
    activeTtext: "贴地",
    inactiveText: "不贴地",
    isShow: true,
  },
  {
    show: "scaleByDistance",
    key: "scaleByDistance",
    type: 5,
    activeTtext: "缩放",
    inactiveText: "不缩放",
    isShow: true,
  },
  {
    show: "scaleByDistance_far",
    key: "scaleByDistance_far",
    type: 4,
    min: 0,
    max: 1000000,
    step: 10,
    isShow: false,
  },
  {
    show: "scaleByDistance_near",
    key: "scaleByDistance_near",
    type: 4,
    min: 1,
    max: 1000000,
    step: 1,
    isShow: false,
  },
  {
    show: "distanceDisplayCondition",
    key: "distanceDisplayCondition",
    type: 5,
    activeTtext: "显示",
    inactiveText: "不显示",
    isShow: true,
  },
  {
    show: "distanceDisplayCondition_far",
    key: "distanceDisplayCondition_far",
    type: 4,
    min: 1,
    max: 1000000, //100000,
    step: 1,
    isShow: false,
  },
  {
    show: "distanceDisplayCondition_near",
    key: "distanceDisplayCondition_near",
    type: 4,
    min: 0,
    max: 100000,
    step: 1,
    isShow: false,
  },
];

// 关于基础属性显示隐藏的
const switchFieldIsShowList = [
  // 背景色
  {
    key: "background",
    value: ["backgroundColor"],
  },
  // 描边色
  { key: "outline", value: ["outlineWidth", "outlineColor"] },
  // 视距缩放
  {
    key: "scaleByDistance",
    value: ["scaleByDistance_far", "scaleByDistance_near"],
  },
  // 视距显示
  {
    key: "distanceDisplayCondition",
    value: ["distanceDisplayCondition_far", "distanceDisplayCondition_near"],
  },
  {
    key: "surfaceOutLine",
    value: ["surfaceOutLineColor", "surfaceOutLineWidth"],
  },
  {
    key: "surfaceFillON",
    value: ["surfaceFillColor"],
  },
];

// 关于显示隐藏切换的函数
const switchfieldIsShow = (key, bool) => {
  let value = switchFieldIsShowList.find((item) => item.key === key)?.value;
  if (value && typeof bool === "boolean") {
    value.forEach((item) => {
      initFormList.find((etem) => etem.key === item).isShow = bool;
    });
  }
};

// 材质下拉框数据对应显示属性（部分）
const selectFieldIsShowList = [
  { key: "Color", value: [] },
  {
    key: "PolylineArrow",
    value: [],
  },
  {
    key: "PolylineDash",
    value: ["dashLength", "gapColor"],
  },
  {
    key: "PolylineOutline",
    value: ["polylineOutlineColor", "polylineOutlineWidth"],
  },
  {
    key: "PolylineGlow",
    value: ["glowPower"],
  },
  {
    key: "ODLine",
    value: ["bgColor", "speed", "bidirectional"],
  },
  {
    key: "LineFlicker",
    value: ["speed"],
  },
  {
    key: "LineTrail",
    value: ["speed"],
  },
  {
    key: "LineBloom",
    value: ["glow", "speed"],
  },
  {
    key: "dynamicArrowCoarse",
    value: ["speed", "repeat_x"],
  },
  {
    key: "dynamicArrowFine",
    value: ["speed", "repeat_x"],
  },
  {
    key: "flowLine",
    value: ["speed", "repeat_x"],
  },
];

// 当修改材质下拉框属性时
const selectfieldIsShow = (key, data) => {
  // 默认隐藏圆（波纹扩散）的数量和圈间系数
  initFormList.find((ztem) => ztem.key === "count").isShow = false;
  initFormList.find((ztem) => ztem.key === "gradient").isShow = false;
  // 判断是不是纯色圆，显示隐藏速度
  if (data?.plotType === "circle" && data?.fillMaterial !== "Color") {
    initFormList.find((ztem) => ztem.key === "speed").isShow = true;
  } else if (data?.plotType === "circle" && data?.fillMaterial === "Color") {
    initFormList.find((ztem) => ztem.key === "speed").isShow = false;
  }
  // 判断是不是圆（波纹扩散）显隐藏数量和圈间系数
  if (data?.plotType === "circle" && data?.fillMaterial === "CircleWave") {
    initFormList.find((ztem) => ztem.key === "count").isShow = true;
    initFormList.find((ztem) => ztem.key === "gradient").isShow = true;
  } else {
    initFormList.find((ztem) => ztem.key === "count").isShow = false;
    initFormList.find((ztem) => ztem.key === "gradient").isShow = false;
  }
  if (data?.plotType === "sphere" && data?.ellipsoidMaterial === "Grid") {
    initFormList.find((ztem) => ztem.key === "cellAlpha").isShow = true;
    initFormList.find((ztem) => ztem.key === "lineCount").isShow = true;
    initFormList.find((ztem) => ztem.key === "lineThickness").isShow = true;
  } else {
    initFormList.find((ztem) => ztem.key === "cellAlpha").isShow = false;
    initFormList.find((ztem) => ztem.key === "lineCount").isShow = false;
    initFormList.find((ztem) => ztem.key === "lineThickness").isShow = false;
  }
  if (
    data?.plotType === "sphere" &&
    (data?.ellipsoidMaterial === "EllipsoidWave" ||
      data?.ellipsoidMaterial === "EllipsoidElectric")
  ) {
    initFormList.find((ztem) => ztem.key === "ellipsoidSpeed").isShow = true;
  } else {
    initFormList.find((ztem) => ztem.key === "ellipsoidSpeed").isShow = false;
  }
  // 是实现修改线型或曲线修改线型就判断线型下拉框
  if (data?.plotType === "solidLine" || data?.plotType === "curve") {
    // 判断当前修改的是不是线型下拉框
    const name = selectFieldIsShowList.find((item) => item.key === key);
    // 没有值返回
    if (!name) {
      return;
    }
    selectFieldIsShowList.forEach((xtem) => {
      // 将当前线型的属性展示
      if (xtem.key === key) {
        xtem.value.forEach((ytem) => {
          initFormList.find((ztem) => ztem.key === ytem).isShow = true;
        });
      } else {
        // 将其他线型的属性隐藏
        xtem.value.forEach((ytem) => {
          initFormList.find((ztem) => ztem.key === ytem).isShow = false;
        });
        if (
          key === "ODLine" ||
          key === "LineFlicker" ||
          key === "LineTrail" ||
          key === "LineBloom" ||
          key === "dynamicArrowCoarse" ||
          key === "dynamicArrowFine" ||
          key === "flowLine"
        ) {
          initFormList.find((ztem) => ztem.key === "speed").isShow = true;
        }
        if (
          key === "dynamicArrowCoarse" ||
          key === "dynamicArrowFine" ||
          key === "flowLine"
        ) {
          initFormList.find((ztem) => ztem.key === "repeat_x").isShow = true;
        }
      }
    });
  }
};

const openWindow = (url, title, w = "800", h = "600") => {
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : screen.left;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : screen.top;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height;

  const left = width / 2 - w / 2 + dualScreenLeft;
  const top = height / 2 - h / 2 + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=" +
      w +
      ", height=" +
      h +
      ", top=" +
      top +
      ", left=" +
      left,
    "_search"
  );
  // alert(this.processLinks2(url));
  // if (window.focus) {
  //   newWindow.focus();
  // }
};

// 统一导出
export {
  selectFieldIsShowList,
  switchFieldIsShowList,
  initFormList,
  selectfieldIsShow,
  switchfieldIsShow,
  isFieldDisplayed,
  changeGraphicStyle,
  graphicDrawFunc,
  clearPlotData,
  deleteAllPlot,
  receivePlotTreeData,
  operationPlotData,
  flyToPlot,
  manageFields,
  getProjectPlotTreeData,
  currentScenePlot,
  matchPlotId,
  changePrevPlotValue,
  getPrevPlotValue,
};
